// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, DisplayError } from "@insite/client-framework/Store/Context/Handlers/HandleError";

export const XNGSaveUnhandledError: typeof DisplayError = props => {
    (props as any).dispatch({
        type: "xCommon/update",
        data: { key: "unhandledError", value: (props.parameter.error as any).errorMessage },
    });
    props.dispatch({
        type: "Context/CompleteUpdatingCart",
    });
};

addToEndOfChain(chain, XNGSaveUnhandledError);
